<template>
  <div class="myTeam" v-if="teamList">
    <div class="team_header van-hairline--bottom">
      <div class="header_top">
        <router-link
          :to="{
            path: '/my/team/list',
            query: {
              id: teamId
            }
          }"
          class="top_left"
        >
          <span v-if="team.title">{{ team.title }}</span
          ><van-icon name="play" color="#666666" />
        </router-link>
        <router-link
          :to="{
            name: 'MyTeamInvite',
            query: {
              key: team.secret_key,
              title: team.title,
              uid: userInfo.uid,
              nickname: userInfo.nickname,
              id: this.teamId
            }
          }"
          class="top_right"
          tag="div"
        >
          <!-- <span class="van-hairline--surround">
            <img src="../../assets/images/lc_share.png" /><span>邀请成员</span>
          </span> -->
          <van-tag plain round size="large"
            ><img
              class="tag_img"
              src="../../assets/images/lc_share.png"
            />邀请成员</van-tag
          >
        </router-link>
      </div>
      <div class="header_bottom">
        <div class="bottom_item">
          <p>{{ TeamGuestCount || 0 }}</p>
          <p>团队获客</p>
        </div>
        <div class="bottom_item">
          <p>{{ HotShareCount || 0 }}</p>
          <p>热文分享</p>
        </div>
      </div>
    </div>
    <div class="team_list">
      <div class="list_header van-hairline--bottom">
        <h4>获客排行榜</h4>
        <div>
          (共<span>{{ teamMembers.count || 0 }}</span
          >人，管理员<span>{{ teamMembers.auth_count || 0 }}</span
          >人)
        </div>
      </div>
      <div class="nav">
        <div
          :class="active == index ? 'nav_item active' : 'nav_item'"
          v-for="(item, index) in navList"
          :key="item.title"
          @click="selectNav(index)"
        >
          <span>{{ item.title }}</span>
        </div>
      </div>
      <van-list
        class="nav_list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <div
          class="list_item"
          v-for="(item, index) in teamMembers.list"
          :key="index"
        >
          <div class="item_left">
            <div class="img_box">
              <img class="head" :src="item.UserInfo[0].avatar" />
              <img
                v-if="index == 0"
                class="icon_img"
                src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_team_one.png"
              />
              <img
                v-if="index == 1"
                class="icon_img"
                src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_team_two.png"
              />
              <img
                v-if="index == 2"
                class="icon_img"
                src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_team_three.png"
              />
            </div>
            <div class="info">
              <p>
                {{ item.UserInfo[0].nickname }}
                <span class="admin">{{
                  item.is_auth == 1
                    ? "管理员"
                    : item.is_auth == 2
                    ? "创建者"
                    : item.is_auth == 3
                    ? "咨询师"
                    : ""
                }}</span>
              </p>
              <p>热门分享 {{ item.HotGuestCount || 0 }}</p>
            </div>
          </div>
          <div class="item_right">
            <p>{{ item.PersonalGuestCount || 0 }}</p>
            <p>客户线索</p>
          </div>
        </div>
      </van-list>
      <div class="invite_btn" v-if="teamMembers.list.length <= 3">
        <p>赶快去邀请伙伴，共同成长吧</p>
        <router-link
          :to="{
            name: 'MyTeamInvite',
            query: {
              key: team.secret_key,
              title: team.title,
              uid: userInfo.uid,
              nickname: userInfo.nickname,
              id: this.teamId
            }
          }"
          tag="span"
        >
          邀请成员
        </router-link>
      </div>
      <p class="noData" v-if="false">没有更多了~</p>
    </div>
    <div class="btns">
      <!-- <div class="item_btn" @click="more_show = true">
        <van-icon name="ellipsis" size=".44rem" color="#999999" />更多
      </div> -->
      <div class="item_btn" @click="quitTeam">退出团队</div>
      <div class="item_btn" v-if="my.is_auth != 0" @click="deleteMember">
        删除成员
      </div>
      <div class="item_btn" v-if="my.is_auth == 2" @click="setAdmin">
        设管理员
      </div>
      <div class="item_btn" v-if="my.is_auth == 2" @click="setCounselor">
        设咨询师
      </div>
    </div>
    <div class="btn" v-if="false" @click="quitTeam">退出团队</div>
    <!-- <div class="team_btn">团队素材</div> -->
    <van-action-sheet
      v-model="more_show"
      :actions="more_actions"
      cancel-text="取消"
      close-on-click-action
      @select="onMoreSelect"
    />
    <router-link tag="div" to="/" class="home">返回首页</router-link>
  </div>
</template>

<script>
import { Icon, Dialog, ActionSheet, List, Toast, Tag } from "vant";
import { getTeamList, getMembersList, postOutTeam } from "@api/public";
import { getUser } from "@api/user";
import { getTeamGuest, getHotShare } from "@api/lcapi";
export default {
  name: "MyTeam",
  components: {
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [ActionSheet.name]: ActionSheet,
    [List.name]: List,
    [Tag.name]: Tag
  },
  data() {
    return {
      userInfo: "",
      teamList: "", //团队列表
      teamId: "", // 团队Id
      teamMembers: "", // 团队成员列表
      TeamGuestCount: "", // 团队获客
      HotShareCount: "", // 团队热文分享
      my: "",
      navList: [
        {
          title: "总榜",
          name: "total_list"
        },
        {
          title: "昨日",
          name: "yesterday"
        },
        {
          title: "本周",
          name: "this_week"
        },
        {
          title: "上周",
          name: "last_week"
        },
        {
          title: "上月",
          name: "last_month"
        }
      ],
      active: 0, // 排行榜选项
      loading: false,
      finished: false
      // more_show: false, // 更多弹窗
      // more_actions: [
      //   { name: "修改团队名称" },
      //   { name: "退出团队", color: "#ff410a" },
      // ], // 更多弹窗选项
    };
  },
  mounted() {
    this.getTeamList();
    const that = this;
    getUser().then(res => {
      that.userInfo = res.data;
    });
  },
  methods: {
    /**
     * 获取团队列表
     */
    getTeamList() {
      getTeamList().then(res => {
        this.teamList = res.data;
        if (this.$route.query.id) {
          this.teamId = this.$route.query.id;
        } else {
          this.teamId = res.data[0].id;
        }
        this.team = this.teamList.find(item => {
          if (item.id == this.teamId) {
            return item;
          }
        });
        this.getMembersList(this.teamId);
        getTeamGuest({ brand_id: this.teamId }).then(res => {
          this.TeamGuestCount = res.data.TeamGuestCount;
        });
        getHotShare({ brand_id: this.teamId }).then(res => {
          this.HotShareCount = res.data.HotShareCount;
        });
      });
    },
    /**
     * 获取团队成员列表
     */
    getMembersList(id) {
      getMembersList({
        brand_id: id,
        data: this.navList[this.active].name
      }).then(res => {
        this.teamMembers = res.data;
        this.loading = true;
        this.finished = true;
        let uid = this.userInfo.uid;
        let arr = res.data.list.find(item => {
          if (item.UserInfo[0].uid == uid) {
            return item;
          }
        });
        this.my = arr;
      });
    },
    /**
     * 退出团队
     */
    quitTeam() {
      postOutTeam({
        team_id: this.teamId
      })
        .then(res => {
          Toast({ message: res.msg });
          this.$router.replace({
            path: "/my"
          });
        })
        .catch(err => {
          Toast({ message: err.msg });
        });
      // Dialog.confirm({
      //   title: "确认退出团队么？",
      // })
      //   .then(() => {
      //     postOutTeam({
      //       team_id: this.teamId,
      //     })
      //       .then((res) => {
      //         Toast({ message: res.msg });
      //         this.$router.replace({
      //           path: "/my",
      //         });
      //       })
      //       .catch((err) => {
      //         Toast({ message: err.msg });
      //       });
      //   })
      //   .catch((err) => {});
    },
    /**
     * 更多选项
     */
    onMoreSelect(item) {
      if (item.name == this.more_actions[0].name) {
        this.$router.replace({ name: "MyTeamChangeName" });
        return;
      }
      if (item.name == this.more_actions[1].name) {
        this.quitTeam();
      }
    },
    /**
     * 删除成员
     */
    deleteMember() {
      let uid = this.userInfo.uid;
      let arr = this.teamMembers.list.find(item => {
        if (item.UserInfo[0].uid == uid) {
          return item;
        }
      });
      let array = [];
      if (arr.is_auth == 0) {
        Toast({ message: "你没有权限！" });
        return;
      } else if (arr.is_auth == 2) {
        this.teamMembers.list.forEach(item => {
          if (item.is_auth != 2) {
            array.push(item);
          }
        });
      } else if (arr.is_auth == 1) {
        this.teamMembers.list.forEach(item => {
          if (item.is_auth == 0) {
            array.push(item);
          }
        });
      }
      if (array.length == 0) {
        Toast({ message: "该团队没有普通成员" });
        return;
      }
      this.$router.push({
        path: "/my/team/deleteMember",
        query: {
          id: this.teamId,
          list: JSON.stringify(array)
        }
      });
    },
    /**
     * 设置管理员
     */
    setAdmin() {
      let uid = this.userInfo.uid;
      let arr = this.teamMembers.list.find(item => {
        if (item.UserInfo[0].uid == uid) {
          return item;
        }
      });
      let array = [];
      if (arr.is_auth != 2) {
        Toast({ message: "你没有权限！" });
        return;
      } else {
        this.teamMembers.list.forEach(item => {
          if (item.is_auth != 2 && item.is_auth != 3) {
            array.push(item);
          }
        });
      }
      if (array.length == 0) {
        Toast({ message: "该团队没有普通成员" });
        return;
      }
      this.$router.push({
        path: "/my/team/setAdmin",
        query: {
          id: this.teamId,
          list: JSON.stringify(array)
        }
      });
    },
    /**
     * 设置咨询师
     */
    setCounselor() {
      let uid = this.userInfo.uid;
      let arr = this.teamMembers.list.find(item => {
        if (item.UserInfo[0].uid == uid) {
          return item;
        }
      });
      let array = [];
      if (arr.is_auth != 2) {
        Toast({ message: "你没有权限！" });
        return;
      } else {
        this.teamMembers.list.forEach(item => {
          if (item.is_auth != 1 && item.is_auth != 2) {
            array.push(item);
          }
        });
      }
      if (array.length == 0) {
        Toast({ message: "该团队没有普通成员" });
        return;
      }
      this.$router.push({
        path: "/my/team/setCounselor",
        query: {
          id: this.teamId,
          list: JSON.stringify(array)
        }
      });
    },
    /**
     * 排行榜nav选择
     */
    selectNav(index) {
      this.active = index;
      this.getMembersList(this.teamId);
    }
  }
};
</script>

<style lang="scss" scoped>
.myTeam {
  min-height: 100vh;
  padding-bottom: 1.2rem;
  .team_header {
    background: #ffffff;
    padding-bottom: 0.2rem;
    .header_top {
      display: flex;
      justify-content: space-between;
      padding: 0 0.3rem;
      height: 1.2rem;
      line-height: 1.2rem;
      .top_left {
        display: flex;
        align-items: center;
        span {
          font-size: 0.44rem;
          font-weight: bold;
        }
      }
      .top_right {
        font-size: 0;
        display: flex;
        align-items: center;
        .tag_img {
          width: 0.26rem;
          height: 0.26rem;
        }
        // .van-hairline--surround::after {
        //   border-radius: 0.5rem;
        //   border-color: #999999 !important;
        // }
        // .van-hairline--surround {
        //   color: #000;
        //   border-radius: 0.5rem;
        //   padding: 0 0.15rem;
        //   display: flex;
        //   align-items: center;
        //   font-size: 0;
        //   span {
        //     display: inline-block;
        //     line-height: 0.4rem;
        //     font-size: 0.24rem;
        //   }
        //   img {
        //     height: 0.26rem;
        //     margin-right: 0.04rem;
        //   }
        // }
      }
    }
    .header_bottom {
      display: flex;
      justify-content: space-between;
      border-radius: 0.1rem;
      background-image: url("../../assets/images/team_bg.png");
      background-size: 100% 100%;
      color: #ffffff;
      margin: 0 0.3rem 0 0.3rem;
      .bottom_item {
        width: 50%;
        text-align: center;
        padding: 0.3rem 0;
        p {
          &:first-child {
            font-size: 0.5rem;
            font-weight: bold;
          }
          &:last-child {
            margin-top: 0.1rem;
            font-size: 0.26rem;
          }
        }
      }
    }
  }
  .team_list {
    .list_header {
      padding: 0.2rem 0.3rem;
      display: flex;
      align-items: center;
      background: #ffffff;
      font-size: 0.3rem;
      div {
        font-size: 0.24rem;
        color: #999999;
        margin-left: 0.1rem;
        span {
          margin: 0 0.05rem;
        }
      }
    }
    .nav {
      display: flex;
      height: 0.7rem;
      line-height: 0.7rem;
      color: #999999;
      padding: 0 0.3rem;
      .nav_item {
        margin-right: 0.5rem;
        font-size: 0.26rem;
        &.active {
          color: #ff410a;
          border-bottom: 2px solid #ff410a;
        }
      }
    }
    .nav_list {
      .list_item {
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        padding: 0.2rem 0.3rem;
        border-bottom: 1px solid #f5f5f5;
        &:last-child {
          border-bottom: 0;
        }
        .item_left {
          flex: 1;
          display: flex;
          .img_box {
            width: 0.8rem;
            height: 0.8rem;
            font-size: 0;
            margin-right: 0.2rem;
            position: relative;
            .head {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
            .icon_img {
              width: 100%;
              height: 0.3rem;
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
            }
          }
          .info {
            p:first-child {
              font-size: 0.32rem;
              font-weight: bold;
              display: flex;
              align-items: center;
              .admin {
                display: inline-block;
                background: #ff410a;
                font-size: 0.24rem;
                color: #fff;
                line-height: 0.32rem;
                padding: 0 0.05rem;
                border-radius: 0.05rem;
                margin-left: 0.1rem;
              }
            }
            p:last-child {
              font-size: 0.24rem;
              color: #999999;
            }
          }
        }
        .item_right {
          padding: 0 0.3rem;
          text-align: center;
          border-left: 2px solid #f5f5f5;
          p:first-child {
            font-size: 0.36rem;
          }
          p:last-child {
            font-size: 0.24rem;
          }
        }
      }
    }
    .noData {
      text-align: center;
      color: #999999;
      background: #f5f5f5;
      line-height: 2rem;
    }
  }
  .btn {
    text-align: center;
    line-height: 0.8rem;
    height: 1rem;
    padding: 0.1rem 0;
    background: #ffffff;
    font-size: 0.24rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #f5f5f5;
    box-shadow: darkgrey 5px 10px 5px 5px;
  }
  .team_btn {
    position: fixed;
    background: #f37d5d;
    right: 0;
    bottom: 2rem;
    z-index: 2000;
    color: #ffffff;
    font-size: 0.24rem;
    line-height: 0.6rem;
    padding: 0 0.3rem;
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }
  .invite_btn {
    text-align: center;
    p {
      color: #999999;
      text-align: center;
      margin-top: 1rem;
    }
    span {
      display: inline-block;
      background: #ff410a;
      color: #ffffff;
      line-height: 0.8rem;
      height: 0.8rem;
      padding: 0 1.5rem;
      border-radius: 0.4rem;
      margin-top: 0.2rem;
    }
  }
  .btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1rem;
    line-height: 0.8rem;
    padding: 0.1rem 0;
    border-top: 1px solid #f5f5f5;
    box-shadow: darkgrey 5px 10px 5px 5px;
    .item_btn {
      flex: 1;
      text-align: center;
      border-right: 2px solid #f5f5f5;
      align-items: center;
      display: flex;
      justify-content: center;
      &:last-child {
        border-right: 0;
      }
    }
  }
  .home {
    position: fixed;
    background: #ff410a;
    right: 0;
    bottom: 1.2rem;
    padding: 0 0.2rem;
    line-height: 0.8rem;
    border-top-left-radius: 0.16rem;
    border-bottom-left-radius: 0.16rem;
  }
}
</style>
